import type { ShareContentType } from '../share-criteria-types.ts';

/**
 * Resolves the per-content-type Post Office trigger id for the "criteria met"
 * nudge.
 *
 * - Primary (first instance):   `flag-to-share-criteria-met.${contentType}`
 * - Nth+ (second+ instance):    `flag-to-share-criteria-met-nth.${contentType}`
 *
 * `isNth` defaults to `false` so today we always fire the primary trigger; the
 * nth branch is kept so it can be enabled later without reshaping callers.
 */
export function getTriggerId(contentType: ShareContentType, isNth: boolean = false): string {
	const base = isNth ? 'flag-to-share-criteria-met-nth' : 'flag-to-share-criteria-met';
	return `${base}.${contentType}`;
}
